import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import Category from '@/views/Category.vue'
import Product from '@/views/Product.vue'
import NotFound from '@/views/NotFound.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/:category',
		name: 'category',
		component: Category
	},
	{
		path: '/:category/:subcategory/:product',
		name: 'subcategory',
		component: Product	
	},
	{
		path: '/:category/:product',
		name: 'product',
		component: Product
	},
	{
        path: '*',
        component: NotFound
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js